import { Component, OnInit, Input } from '@angular/core';
import { Scene } from '@spi/Engine/Scene';

@Component({
  selector: 'app-scene-debug',
  templateUrl: './scene-debug.component.html',
  styleUrls: ['./scene-debug.component.less']
})
export class SceneDebugComponent implements OnInit {

  @Input()
  public scene: Scene;

  constructor() { }

  ngOnInit() {
  }

  public toggle(name: string, state: boolean) {
    this.scene.debugManager.setEnabledState(name, state);
  }

}
